function vcard({ nom, rue, ville, numero }) {
  return `BEGIN:VCARD
VERSION:3.0
FN:${nom}
ADR;TYPE=PARCEL:;;${rue};${ville};;;France
TEL;TYPE=CLIENT:${numero}
END:VCARD`;
}

export default vcard;
